import {RookieDistrictFullData} from "../../../app/interfaces/rookie/rookie-district-full-data";
import {Image} from "../../../app/interfaces/image";
import {RookieDistrictState} from "../../../app/enums/rookie/rookie-district-state";

const placeHolderDir = "/assets/img/placeholders/";
const imageFileName = "BER_final_Placeholder_Arrow_01.svg";

const bentoCurrentYear: number = new Date().getFullYear();

const placeholderImage: Image = {
  huge: {url: placeHolderDir + imageFileName, width: 1000},
  info: {caption: "Bild nicht gefunden", copyright: "Berufsreise.at", alttext: "Bild nicht gefunden"},
  landscape: {url: placeHolderDir + imageFileName, width: 100},
  large: {url: placeHolderDir + imageFileName, width: 700},
  medium: {url: placeHolderDir + imageFileName, width: 500},
  portrait: {url: placeHolderDir + imageFileName, width: 400},
  xlarge: {url: placeHolderDir + imageFileName, width: 1500}
};

export default {
  id: 1,
  name: "Schwaz",
  eventType: 1,
  state: RookieDistrictState.NOTSET,
  mainEventFromToString: "30.10. – 11.11.2026",
  scholar: {
    register_success: {
      title: "Vielen Dank für deine Anmeldung!",
      text: "Die Daten wurden erfolgreich abgesendet und du erhältst in wenigen Minuten eine Bestätigung per E-Mail. " +
        "Bitte überprüfe auch deinen SPAM-Ordner. Solltest du innerhalb von 24 Stunden keine Bestätigung erhalten " +
        "haben, bitten wir dich, Kontakt mit uns aufzunehmen.",
      questions: "Bei Fragen steht dir gerne die Wirtschaftskammer Schwaz unter " +
        "E&nbsp;<a href=\"mailto:schwaz@wktirol.at\">schwaz@wktirol.at</a> und " +
        "T&nbsp;<a href=\"tel:05909053710\">05 90 90 5-3710</a> zur Verfügung."
    },
    register_errors: {
      ALREADY_REGISTERED: {
        title: "Du bist bereits angemeldet!",
        text: "Mit deinen Daten wurde bereits ein Schnupperplatz registriert. Pro Schüler:in ist nur ein " +
          "Schnupperplatz möglich, da sich die Termine sonst überschneiden. Mehr Informationen über den Ablauf " +
          "findest du auf der Startseite."
      }
    }
  },
  providerRegisterTime: {
    closeAt: "",
    openAt: "",
  },
  companySignup: {
    head_title: "Ermöglichen Sie<br/> <em>jungen Talenten</em> <br/>Einblicke in Ihr<br/> Unternehmen",
    head_text: "Mit einer Teilnahme an Rookie geben Sie Schüler:innen der 8. Schulstufe die Möglichkeit, " +
      "einzigartige Einblicke in Ihr Unternehmen zu erhalten. Sie lernen motivierte, junge Talente kennen und " +
      "können Ihr Unternehmen und Ausbildungsangebot direkt erlebbar machen.",
    contact: "Die Anmeldung für Rookie Schwaz ist aktuell geschlossen. Bei Fragen steht Ihnen " +
      "Frau Barbara Margreiter, BEd aus der Bezirksstelle Schwaz unter " +
      "T&nbsp;<a href=\"tel:+435909053712\">+43 5 90 905 3712</a> oder " +
      "E&nbsp;<a href=\"mailto:barbara.margreiter@wktirol.at\">barbara.margreiter@wktirol.at</a> zur Verfügung.",
  },
  timeSlots: [],
  districtSelector: {
    iconSrc: "/assets/img/rookie/district-selector/schwaz-bezirk.svg",
    description: "Finde deinen Schnupperplatz in Schwaz."
  },
  home: {
    hero: {
      title: "Finde deinen Schnupperplatz in <em>Schwaz</em>",
      icons: [
        "/assets/img/icons/rookie/PATCH-1-Schwaz.svg",
        "/assets/img/icons/rookie/PATCH-2-Schwaz.svg",
        "/assets/img/icons/rookie/PATCH-3-Schwaz.svg",
        "/assets/img/icons/rookie/PATCH-4-Schwaz.svg"
      ],
      text: "Bald ist es wieder soweit und Rookie - Schüler:innen in Betrieben geht in die nächste Runde. " +
        "Über den Anmeldestart wirst du rechtzeitig von deiner Lehrperson sowie online über diese Seite informiert."
    },
    functions: {
      title: "So funktioniert <em>Rookie Tirol</em>",
      cards: [
        {
          index: 1,
          title: 'Deinen Schnupperplatz finden',
          hint: "",
          iconSrc: '/assets/img/icons/UA-Betriebserkundungen.svg',
          text: 'Finde deine persönlichen Favoriten für deinen Schnuppertag. Tipp: Noch schneller gelangst du am ' +
            'Tag der Anmeldung zum Anmeldeformular mit dem individuellen Code.',
          checklistTitle: 'Checkliste für Schüler:innen:',
          checklistItems: [
            'Schnupperplatz auswählen',
            'Anmeldeformular abschicken',
            'Bestätigungsmail erhalten von Datum und Dauer des Schnuppertermins'
          ]
        },
        {
          index: 2,
          title: 'Für Schnupperplatz anmelden',
          hint: "Anmeldung ausschließlich über diese Website",
          iconSrc: '/assets/img/icons/Berufsfelder-Medien-Kultur.svg',
          text: 'Sei pünktlich zum Anmeldestart online. Eine erfolgreiche Anmeldung wird dir am Bildschirm sowie ' +
            'mit einer E-Mail bestätigt. In dieser werden nochmal alle Informationen zum Angebot sowie ' +
            'Kontaktinformationen zum Unternehmen zusammengefasst.',
          checklistTitle: 'Checkliste für Schüler:innen:',
          checklistItems: [
            'Sei pünktlich online',
            'Wähle deinen Schnupperplatz aus',
            'Schicke das Anmeldeformular ab',
            'Bei erfolgreicher Anmeldung: Bestätigungsmail erhalten',
            'Bei ausgebuchtem Angebot: Alternative suchen und buchen'
          ]
        },
        {
          index: 3,
          title: 'Telefonische Kontaktaufnahme',
          hint: "",
          iconSrc: '/assets/img/icons/BO-Vortrag.svg',
          text: 'Nach erfolgreicher Anmeldung erhältst du eine E-Mail mit allen wichtigen Informationen. Melde ' +
            'dich bei deiner Kontaktperson, stelle dich kurz vor und kläre Rahmenbedingungen wie Dauer oder ' +
            'Bekleidungsvorschriften. Als Leitfaden erhältst du in der Schule einen Fragebogen.',
          checklistTitle: 'Wichtige Fragen klären:',
          checklistItems: [
            'Wann beginnt die Arbeit?',
            'Wo ist der Treffpunkt?',
            'Welche Kleidung soll ich tragen?',
            'Gibt es etwas Besonderes zu beachten?'
          ]
        },
        {
          index: 4,
          title: 'Schnuppertag absolvieren',
          hint: "",
          iconSrc: '/assets/img/icons/UA-Berufspraktische-Tage.svg',
          text: 'Am Schnuppertag bekommst du einen einmaligen Einblick in Berufe im ausgewählten Unternehmen. ' +
            'Nutze die Gelegenheit, erste berufliche Erfahrungen zu sammeln, Fragen zu stellen und finde heraus, ' +
            'ob der Beruf zu dir passt. ',
          checklistTitle: 'Checkliste für Schüler:innen:',
          checklistItems: [
            'Erscheine pünktlich',
            'Trage passende Kleidung',
            'Arbeite aufmerksam mit und stelle Fragen',
            'Beachte Sicherheitsanweisungen und Vorgaben'
          ]
        },
        {
          index: 5,
          title: 'Feedback abgeben',
          hint: "",
          iconSrc: '/assets/img/icons/Berufsfelder-Medien-Kultur.svg',
          text: 'Nach den Schnuppertagen erhältst du einen Feedbackbogen. Hat dir etwas besonders gut gefallen, ' +
            'wurden deine Erwartungen erfüllt, wurdest du in deiner Berufswahl bestärkt? Hier kannst du dein ' +
            'Feedback festhalten.',
          checklistTitle: 'Checkliste für Schüler:innen:',
          checklistItems: [
            'Erhalte den Feedbackbogen von deiner Lehrperson',
            'Gib Rückmeldung zu deinen Erfahrungen',
            'Was hat dir gefallen?',
            'Verbesserungsvorschläge'
          ]
        }
      ]
    },
    bentoItems: [
      {
        type: "simple",
        width: "2",
        images: [
          {
            image: "/assets/img/rookie/start-bento/01.svg",
            imagePosition: "center"
          }
        ],
        cardTexts: [
          {text: "2 Tage", textPosition: "center"},
          {text: "in Betrieben schnuppern", textPosition: "bottom"}
        ],
        backgroundColor: "red"
      },
      {
        type: "slider",
        width: "3",
        backgroundColor: "blue",
        slides: [
          {
            title: "Praxisnah in Unternehmen hineinschnuppern",
            image: "/assets/img/rookie/start-bento/02-1.svg",
            color: "blue"
          },
          {
            title: "Berufe hautnah erleben",
            image: "/assets/img/rookie/start-bento/02-02.svg",
            color: "rock"
          },
          {
            title: "Unternehmen aus deinem Bezirk",
            image: "/assets/img/rookie/start-bento/02-03.svg",
            color: "yellow"
          }
        ]
      },
      {
        type: "video",
        width: "5",
        videoUrl: "/assets/img/rookie/start-bento/bento.mp4",
        videoThumbnail: "/assets/img/games/previews/guess-image.png"
      },
      {
        type: "animation",
        width: "4",
        animationFile: "/assets/img/rookie/start-bento/jahreszahlen/04-" + bentoCurrentYear + ".svg",
        backgroundColor: "light-blue"
      },
      {
        type: "slider",
        width: "3",
        backgroundColor: "green",
        slides: [
          {
            title: "Unternehmen präsentieren",
            image: "/assets/img/rookie/start-bento/05-1.svg",
            color: "green"
          },
          {
            title: "Zukünftige Lehrlinge kennen lernen",
            image: "/assets/img/rookie/start-bento/05-01.svg",
            color: "light-blue"
          },
          {
            title: "Begeisterung wecken",
            image: "/assets/img/rookie/start-bento/05-02.svg",
            color: "river"
          }
        ]
      },
      {
        type: "simple",
        width: "3",
        backgroundColor: "river",
        backgroundImage: "/assets/img/rookie/start-bento/06.svg",
        cardTexts: [
          {
            text: "Präsentiere dein Unternehmen und finde motivierte Talente",
            textPosition: "center"
          }
        ]
      }
    ],
    dates: {
      title: "Wichtige <em>Termine</em>",
      text: "Ab wann ist eine Anmeldung möglich und in welchem Zeitraum finden die Schnuppertage statt? Hier " +
        "findest du alles, was du dazu wissen musst.",
      cards: [{
        iconSrc: "/assets/img/icons/UA-Vorstellung.svg",
        title: "Anmeldung geöffnet",
        rows: [],
        labelText: "Vormerken und nicht verpassen!",
        labelIcon: "requirement--Risikobewusstsein--278"
      },
        {
          iconSrc: "/assets/img/icons/Auslandspraktika.svg",
          title: "Schnuppertage",
          rows: [],
          labelText: "6 Grossartige Tage",
          labelIcon: "star"
        }]
    },
    testimonials: {
      title: "Was sagen <em>andere?</em>",
      text: "Was sagen andere Schüler:innen zu Rookie? Welche Highlights sind Unternehmer:innen besonders in " +
        "Erinnerung geblieben. Hier teilen wir ihre persönlichen Erfahrungen:",
      visible: false,
      cards: [
        {
          text: "Dank Rookie Day habe ich meinen neuen Lehrling gefunden. Die Schnuppertage geben einem als " +
            "Unternehmer die Chance, junge Talente ganz unkompliziert kennenzulernen. Unser Match war sofort klar. " +
            "Ich kann Rookie wirklich jedem Betrieb empfehlen, der motivierte Nachwuchskräfte sucht.",
          name: "Stefan Lechleitner",
          position: "Huangart | Design & Code",
          avatar: placeholderImage,
          logo: placeholderImage
        },
        {
          text: "Ich dachte, ich würde für immer im Keller meiner Eltern wohnen und Videospiele zocken. Dann kam " +
            "Rookie und plötzlich habe ich einen Job, bei dem ich sogar Geld bekomme! Wer hätte gedacht, dass " +
            "Arbeiten gar nicht so übel ist?",
          name: "Kevin Müller",
          position: "Ex-Kellerexperte, jetzt IT-Lehrling",
          avatar: placeholderImage
        },
        {
          text: "Früher haben wir Lehrlinge über Zeitungsanzeigen gesucht. Das war so effektiv wie ein Fax an einen " +
            "Pinguin zu schicken. Mit Rookie finden wir jetzt tatsächlich Menschen, die nicht nur aus Versehen " +
            "auf unsere Anzeige geklickt haben!",
          name: "Franz Huber",
          position: "Chef vom Chef, Metallbau Huber",
          avatar: placeholderImage,
          logo: placeholderImage
        },
        {
          text: "Meine Mutter meinte, ich sollte was 'Vernünftiges' lernen. Dank Rookie habe ich herausgefunden, " +
            "dass Bäcker werden echt cool ist. Jetzt esse ich jeden Tag frisches Brot und Mama ist stolz. Win-Win!",
          name: "Lukas Brotlieb",
          position: "Bäckerlehrling mit Mission",
          avatar: placeholderImage
        },
        {
          text: "Unser letzter Lehrling hat sich während des Schnuppertags selbst ausgesperrt. Dreimal. Trotzdem " +
            "haben wir dank Rookie noch vier andere tolle Kandidaten gefunden. Die Plattform ist idiotensicher – " +
            "das mussten wir leider testen.",
          name: "Sabine Chaos",
          position: "Inhaberin, Friseursalon Schnittig",
          avatar: placeholderImage,
          logo: placeholderImage
        }
      ]
    },
    startFotos: {
      media: [
        {
          image: "/assets/img/rookie/start-fotos/bereit-links.png",
          video: "/assets/img/rookie/start-fotos/bereit-links.mp4"
        },
        {
          image: "/assets/img/rookie/start-fotos/bereit-mitte.png",
          video: "/assets/img/rookie/start-fotos/bereit-mitte.mp4"
        },
        {
          image: "/assets/img/rookie/start-fotos/bereit-rechts.png",
          video: "/assets/img/rookie/start-fotos/bereit-rechts.mp4"
        }
      ]
    },
    faq: {
      categories: [
        {
          title: "Für Schüler:innen",
          items: [
            {
              question: "Was ist Rookie?",
              answer: "Rookie Schwaz ermöglicht es dir, erste berufliche Erfahrungen in einem Beruf zu sammeln. " +
                "Ziel ist es, den entsprechenden Beruf hautnah zu erleben und somit besser kennenzulernen."
            },
            {
              question: "Wie kann ich mich für Rookie Schnuppertage anmelden?",
              answer: "Eine Anmeldung ist ausschließlich über " +
                "<a href=\"https://www.berufsreise.at/rookie/schwaz\">www.berufsreise.at/rookie/schwaz</a> möglich. " +
                "Eine Anmeldung direkt über das Unternehmen ist aus organisatorischen Gründen nicht möglich."
            },
            {
              question: "Wann kann ich mich für den gewünschten Schnuppertag anmelden?",
              answer: "Wann genau die Anmeldung für die Schnuppertage beginnt, ist beim jeweiligen Angebot hinterlegt."
            },
            {
              question: "Was ist bei der Anmeldung zu beachten?",
              answer: "Sei am Tag der Anmeldung rechtzeitig online. Lade die Seite mit Anmeldestart neu melde dich " +
                "über das Anmeldeformular für den gewünschten Schnupperplatz an. Die Anzahl der Schnupperplätze ist " +
                "pro Angebot begrenzt. Es gilt das first come – first service Prinzip. Ob deine Anmeldung erfolgreich " +
                "war, wird dir nach dem Absenden des Formulars angezeigt und du erhältst eine Bestätigungs-E-Mail."
            },
            {
              question: "Was hat es mit dem Code bei den Schnupperplätzen auf sich?",
              answer: "Jedes Angebot hat einen individuellen Code. Damit du am Anmeldetag schnell zum gewünschten " +
                "Schnupperplatz findest, kannst du den Code in der Menüleiste unter „Zum Schnupperplatz mit Code“ " +
                "eingeben."
            }
          ]
        },
        {
          title: "Für Unternehmen",
          items: [
            {
              question: "Worum handelt es sich bei Rookie?",
              answer: "Rookie ist ein Projekt der Bezirksstelle Schwaz der Wirtschaftskammer Tirol welches " +
                "Schüler:innen ermöglicht, an zwei Schnuppertagen erste berufliche Erfahrungen in Unternehmen aus der " +
                "Region zu sammeln."
            },
            {
              question: "Wie kann ich als Unternehmen an Rookie teilnehmen?",
              answer: "Unternehmen aus dem Bezirk Schwaz haben die Möglichkeit teilzunehmen. Das Anmeldeformular " +
                "wird jeweils im Frühjahr durch die Bezirksstelle Schwaz der Wirtschaftskammer Tirol ausgesendet."
            },
            {
              question: "An wen kann ich mich bei Fragen wenden?",
              answer: "Frau Barbara Margreiter, BEd aus der Bezirksstelle Schwaz der Wirtschaftskammer Tirol steht " +
                "Ihnen gerne bei Fragen unter T&nbsp;<a href=\"tel:+435909053712\">+43 5 90 905 3712</a> oder " +
                "E&nbsp;<a href=\"mailto:barbara.margreiter@wktirol.at\">barbara.margreiter@wktirol.at</a> zur Verfügung."
            },
            {
              question: "Welche Schulstufe nimmt an Rookie teil?",
              answer: "Schüler:innen der 8. Schulstufe der Mittelschulen aus dem Bezirk nehmen an den Rookie " +
                "Schnuppertagen teil."
            },
            {question: "Was kostet die Teilnahme?", answer: "Die Teilnahme ist kostenlos. "},
            {
              question: "Wie viele Schnupperplätze kann ich anbieten?",
              answer: "Pro Lehrberuf und Standort können Sie maximal 4 Jugendlichen einen Schnupperplatz anbieten."
            },
            {
              question: "Wie werde ich über Buchungen in Kenntnis gesetzt?",
              answer: "Sobald eine Buchung erfolgreich durchgeführt wurde, erhalten Sie eine E-Mail mit allen " +
                "wichtigen Informationen. Diese E-Mail wird ebenfalls an den Schüler/die Schülerin sowie die Schule " +
                "und die Bezirksstelle gesendet."
            },
            {
              question: "Wie lange dauert ein Schnuppertag?",
              answer: "Die Schnuppertage dürfen nur zu typischen Unterrichtszeiten (Mo-Fr 8:00 bis 18:00 Uhr) und " +
                "nicht länger als 8 Stunden täglich im Betrieb sein."
            },
            {
              question: "Wie sind die Jugendlichen versichert?",
              answer: "Es handelt sich hierbei um eine schulbezogene Veranstaltung, die Schüler:innen sind somit " +
                "über die Schule versichert."
            },
            {
              question: "Welche rechtlichen Rahmenbedingungen sind zu beachten?",
              answer: "Wichtige Informationen zum Thema Rechte und Pflichten bei Schnuppertagen finden Sie " +
                "beispielsweise auf den Seiten der " +
                "<a href=\"https://www.wko.at/tirol/bildung-lehre/die-schnupperlehre\" target='_blank'>WKO</a>, " +
                "von der <a href=\"https://tirol.arbeiterkammer.at/schnuppern\" target='_blank'>AK</a> und der " +
                "<a href=\"https://www.gesundheitskasse.at/cdscontent/?contentid=10007.904908&portal=oegkdgportal\" target='_blank'>ÖGK</a>."
            },
          ]
        }
      ]
    }
  }
} as RookieDistrictFullData;
